import {Breadcrumbs, CircularProgress, Grid, Typography} from '@mui/material';
import {Home, Rule} from '@mui/icons-material';
import PageTitle from '../../../common/PageTitle';
import LinkNavegacao from '../../../common/Link';
import CardOption from '../../../common/CardOption';
import { ElectronicsIcon } from '../../../common/Icons';
import React, {useEffect, useState} from "react";
import {verifyUserAbilities} from "../../../config/functions";
import HomeIcon from "@mui/icons-material/Home";
import LanIcon from "@mui/icons-material/Lan";
import {useQuery} from "@tanstack/react-query";
import {carregaEquipamentosAll} from "./configs/functions";
import { useAppContext } from '../../../../contexts/AppContext';

function Equipments() {
    const { dadosUsuario } = useAppContext();
    const isSempher = dadosUsuario?.isSempher ?? false;

    const [abilities, setAbilities] = useState({});
    const [loading, setLoading] = useState(false);

    const { data: resumoData, isLoading: isLoadingResumo } = useQuery({
        queryKey: ['resumoEquipamentos'],
        queryFn: () => carregaEquipamentosAll(),
        staleTime: 1000 * 60 * 5
    });

    const permissoesNecessarias = [
        { rota: "equipamento", tipo: 'maquina', title: "Máquinas", description: "Gerencie suas máquinas", url: 'maquinas' },
        { rota: "equipamento", tipo: 'balcao', title: "Balcões", description: "Gerencie seus balcões", url: 'balcoes' },
        { rota: "equipamento", tipo: 'virtual', title: "Balcões Virtuais", description: "Gerencie seus balcões virtuais", url: 'balcoes_virtuais' },
        { rota: "armarios", tipo: 'armario', title: "Armários", description: "Gerencie seus armários", url: 'armarios' },
    ];

    useEffect(() => {
        const carregarPermissoes = async () => {
            setLoading(true);

            const resultados = {};

            for (const item of permissoesNecessarias) {
                resultados[item.rota] = await verifyUserAbilities({ rota: item.rota });
            }

            setAbilities(resultados);
            setLoading(false);
        };

        carregarPermissoes();
    }, []);

    if (loading || isLoadingResumo) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ height: "100vh" }}>
                <CircularProgress />
            </Grid>
        );
    }

    const totais = resumoData?.data?.total ?? {};
    const cardsVisiveis = isSempher
        ? permissoesNecessarias
        : permissoesNecessarias.filter((item) => (totais[item.tipo] ?? 0) > 0);

    return (<>
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="stretch"
            spacing={3}

        >
            <Grid item xs={12}>
                <Breadcrumbs>
                    <LinkNavegacao to='/'><HomeIcon fontSize='small' /></LinkNavegacao >
                    <LinkNavegacao to='/epis'>Gestão de EPI's</LinkNavegacao >
                    <LinkNavegacao to='/epis/equipamentos'>Equipamentos</LinkNavegacao >
                </Breadcrumbs>
                <PageTitle icon={<LanIcon fontSize='large' />} title='Equipamentos' />
            </Grid>

            {cardsVisiveis.map((item) => {
                const temPermissao = abilities[item.rota]?.data.success;
                return (
                    <Grid
                        key={item.rota}
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={4}
                        xl={3}
                        sx={{
                            opacity: temPermissao ? 1 : 0.5,
                            pointerEvents: temPermissao ? 'auto' : 'none',
                        }}
                    >
                        <CardOption
                            title={item.title}
                            description={item.description}
                            url={item.url}
                            hasPermisson={temPermissao}
                            sx={{
                                backgroundColor: temPermissao ? 'transparent' : 'gray',
                                color: temPermissao ? 'black' : 'gray',
                            }}
                        />
                    </Grid>
                );
            })}
        </Grid>
    </>);
}

export default Equipments;